import { render, staticRenderFns } from "./MypageRequestModal.vue?vue&type=template&id=1074a120&scoped=true"
import script from "./MypageRequestModal.vue?vue&type=script&lang=js"
export * from "./MypageRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074a120",
  null
  
)

export default component.exports